import { render, staticRenderFns } from "./salesBestOfTheBest.vue?vue&type=template&id=79d1c390&"
import script from "./salesBestOfTheBest.vue?vue&type=script&lang=js&"
export * from "./salesBestOfTheBest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports